import React from 'react';

import Share from '@components/shared/images/atoms/Share/Share';
import ButtonSvgIcon from '@components/shared/buttons/svg-icon/ButtonSvgIcon';

import styles from './ShareButton.module.scss';

interface IShareButtonProps {
  className?: string;
  disabled?: boolean;
  onClick?: () => void;
}

const ShareButton = ({
  className = '',
  disabled = false,
  onClick
}: IShareButtonProps) => (
  <ButtonSvgIcon
    classNames={ `${styles.ShareButton} ${className} share-button` }
    data-test="share-button"
    disabled={ disabled }
    onClick={ onClick }
  >
    <i className={ styles.Icon } role="img" aria-label="Share">
      <Share />
    </i>
  </ButtonSvgIcon>
);

export default ShareButton;
